import FormControl from "../base/FormControl";

export default class InputDate extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "date";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}